// removed by extract-text-webpack-plugin
module.exports = {"globalFooter":"antd-pro-global-footer-globalFooter","links":"antd-pro-global-footer-links","copyright":"antd-pro-global-footer-copyright"};


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/src/components/GlobalFooter/index.less
// module id = 615
// module chunks = 0